import { render, staticRenderFns } from "./AlarmCategory.vue?vue&type=template&id=34d246d0"
import script from "./AlarmCategory.vue?vue&type=script&lang=js"
export * from "./AlarmCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports